import { Modal, Typography } from '@duxton-web/ui';
import React from 'react';

type SmartCommsUnsavedChangesConfirmationModalProps = {
  isOpen: boolean;
  isCreateSmartCampaignMode: boolean;
  onClose: () => void;
  onDelete: () => void;
  onSaveAsDraft: () => void;
};

const SmartCommsUnsavedChangesConfirmationModal = ({
  isOpen,
  isCreateSmartCampaignMode = false,
  onClose,
  onDelete,
  onSaveAsDraft,
}: SmartCommsUnsavedChangesConfirmationModalProps) => {
  return (
    <Modal
      centered
      width={440}
      open={isOpen}
      cancelText={isCreateSmartCampaignMode ? 'Delete' : 'Leave anyway'}
      okText={isCreateSmartCampaignMode ? 'Save as draft' : 'Save'}
      title={isCreateSmartCampaignMode ? 'Save the campaign?' : 'Save Your Progress'}
      onOk={onSaveAsDraft}
      onCancel={onClose}
      styles={{ body: { paddingRight: 10 } }}
      cancelButtonProps={{
        danger: isCreateSmartCampaignMode,
        type: isCreateSmartCampaignMode ? 'primary' : 'text',
        onClick: onDelete,
      }}
    >
      <Typography.Body level={3}>
        {isCreateSmartCampaignMode ?
          'Before you leave the page, save the campaign as draft to keep your progress.' :
          'Your changes are unsaved. Make sure to save your progress before going back.'
        }
      </Typography.Body>
    </Modal>
  );
};

export default SmartCommsUnsavedChangesConfirmationModal;
